import * as React from "react";
const SvgFiRrBillArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bill-arrow_svg__a)">
      <path
        fill="#062147"
        d="M14.289 4.203a1 1 0 0 1 .009-1.414L16.503.612a2.1 2.1 0 0 1 2.968.004l2.228 2.168a1 1 0 1 1-1.395 1.433l-1.302-1.268v6.052a1 1 0 0 1-2 0V2.93l-1.297 1.281a1 1 0 0 1-1.414-.008zM18.5 11a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 18.5 11m0 7a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 18.5 18m-13-7a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 11M16 16c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4m-2 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2m-8.5 2a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 5.5 18m17.25-8.308a1 1 0 1 0-1.499 1.325c.483.547.75 1.251.75 1.983v6c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-6c0-1.654 1.346-3 3-3h9a1 1 0 0 0 0-2H5c-2.757 0-5 2.243-5 5v6c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5v-6c0-1.22-.444-2.394-1.25-3.308"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bill-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBillArrow;
